import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Layout from './components/LayoutMobile';

const MobileRoute = ({
  component: Component,
  componentKey,
  render,
  ...rest
}) => {
  
  const auth = localStorage.getItem("token");

  return (
    <Route
      {...rest}
      render={props => {
        if (!auth) {
          return <Redirect to={'/'} />;
        }

        if (componentKey !== undefined && componentKey !== null) {
          props.key =
            typeof componentKey === 'function'
              ? componentKey(props)
              : componentKey;
        }

        return (
          <Layout>
            {Component ? (
              <Component {...props} />
            ) : render ? (
              render(props)
            ) : null}
          </Layout>
        );
      }}
    />
  );
};

export default MobileRoute;
